import React, { useState } from "react";
import "./CommentSection.css";

function CommentSection() {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const handleAddComment = () => {
    if (newComment.trim() === "") return;
    setComments([...comments, newComment]);
    setNewComment("");
  };

  return (
    <section className="comment-section">
      <h2>Comments</h2>
      <div className="comment-box">
        <textarea
          placeholder="Share your thoughts..."
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        ></textarea>
        <button onClick={handleAddComment}>Post Comment</button>
      </div>

      <div className="comments-list">
        {comments.length === 0 ? (
          <p>No comments yet. Be the first to share your thoughts!</p>
        ) : (
          comments.map((comment, index) => (
            <div key={index} className="comment-item">
              <p>{comment}</p>
            </div>
          ))
        )}
      </div>
    </section>
  );
}

export default CommentSection;
